import { Chip } from "@mui/material";
import { Actions } from "../components/buttons/Actions";
import { Tag } from "antd";
import { useFirebase } from "./firebase/useFirebase";
import { Link } from "react-router-dom";
import { dateFormat, dateTimeFormat } from "../utils/formatter";
import {
  CANCELLED,
  CONFIRMED,
  DELIVERED,
  IN_PROGRESS,
  NOT_PAID,
  PAID,
  PENDING,
  STATUS_CASH_ON_DELIVERY,
} from "../constants/webapp";
import { serverTimestamp } from "firebase/firestore";
import { actionsColumn } from "../constants/objects";
import { sPending } from "../constants/strings";

export function OrderStatus({ status }) {
  var text;
  var color;

  if (status === PENDING) {
    text = sPending;
    color = "yellow";
  } else if (status === CONFIRMED) {
    text = "Confirmed";
    color = "blue";
  } else if (status === IN_PROGRESS) {
    text = "In Progress";
    color = "blue";
  } else if (status === DELIVERED) {
    text = "Delivered";
    color = "green";
  } else if (status === CANCELLED) {
    text = "Cancelled";
    color = "red";
  }

  return (
    <Tag style={{ margin: 0 }} color={color}>
      {text}
    </Tag>
  );
}

export function PaymentStatus({ status }) {
  var text;
  var color;

  if (status === PAID) {
    text = "Paid";
    color = "green";
  } else if (status === NOT_PAID) {
    text = "Not Paid";
    color = "red";
  }

  return (
    <Tag style={{ margin: 0 }} color={color}>
      {text}
    </Tag>
  );
}

export function PaymentType({ status }) {
  var text;
  var color;

  switch (status) {
    case 1:
      text = "Cash On Delivery";
      color = "yellow";
      break;

    case 2:
      text = "Mobile Money";
      color = "green";
      break;

    default:
      break;
  }

  return (
    <Tag style={{ margin: 0 }} color={color}>
      {text}
    </Tag>
  );
}

export const useOrders = () => {
  const { updateData } = useFirebase();

  const ordersTableData = (data) => [
    ...data.map((item) => {
      const newTimestamp = dateTimeFormat(item?.timestamp, null, true);

      // update the order status
      function OrderActions(status) {
        if (status !== item.order_status) {
          var timestamp = null;
          // delivered status
          if (status === 3) {
            timestamp = serverTimestamp();
          }
          updateData(item.docRef, {
            order_status: status,
            delivered_on: timestamp,
          });
        }
      }

      // update the payment status
      function PaymentActions(status) {
        if (status !== item.payment_status)
          updateData(item.docRef, { payment_status: status });
      }

      function getPaymentActions(status) {
        var actions = [];
        if (item.payment_type === STATUS_CASH_ON_DELIVERY) {
          actions = [
            { action: "Paid", click: () => PaymentActions(1) },
            { action: "Not Paid", click: () => PaymentActions(0) },
          ];
        }
        return actions;
      }

      // create order data without docRef
      var orderData = Object.assign({}, item);
      delete orderData.docRef;
      orderData.timestamp = newTimestamp;
      orderData.delivered_on = dateFormat(item.delivered_on);
      // "DD MMM YYYY @ hh:mm"

      const row = {
        order_id: (
          <div style={{ whiteSpace: "nowrap" }}>
            {/* New Order */}
            {orderData.read === 1 && (
              <Chip label="New" color="success" sx={{ mr: 2 }} />
            )}

            <Link to="details" state={{ orderData: orderData }}>
              {"ID - " + item.id}
            </Link>
          </div>
        ),
        full_name: item?.address?.full_name,
        timestamp: newTimestamp,
        order_status: <OrderStatus status={item.order_status} />,
        payment_status: <PaymentStatus status={item.payment_status} />,
        payment_type: <PaymentType status={item.payment_type} />,

        actions: (
          <Actions
            actions={[
              ...getPaymentActions(),
              { action: "Confirmed", click: () => OrderActions(1) },
              { action: "In Progress", click: () => OrderActions(2) },
              { action: "Delivered", click: () => OrderActions(3) },
              { action: "Cancel", click: () => OrderActions(4), confirm: true },
            ]}
          />
        ),
      };
      return row;
    }),
  ];

  const ordersTableColumns = [
    { id: "order_id", title: "Order Number", align: "left" },
    { id: "full_name", title: "Customer" },
    { id: "timestamp", title: "Order Date" },
    { id: "order_status", title: "Status" },
    { id: "payment_status", title: "Payment" },
    { id: "payment_type", title: "Payment Type" },
    actionsColumn,
  ];

  return { ordersTableColumns, ordersTableData };
};
